export default __webpack_public_path__ + "static/media/ux_after_login.8c9ad615.png";